<app-toast></app-toast>

<div class="auth-container">
  <app-auth-side-panel></app-auth-side-panel>

  <div class="form-panel">
    <div class="form-content">
      <div class="brand-row">
        <img src="/assets/images/LogoMark.png" alt="Logo" class="logo-mark" />
        <span class="brand-title">Document Processing Engine</span>
      </div>

      <h1 class="main-heading">Login to your account</h1>
      <p class="subtext">Create your workspace in seconds.</p>

      <form class="auth-form" (ngSubmit)="onLogin()">
        <app-text-input
          label="Work Email"
          placeholder="jane@acme.com"
          type="email"
          [value]="loginEmail"
          (valueChange)="loginEmail = $event"
          [errorMessage]="emailError"
        ></app-text-input>

        <app-text-input
          label="Password"
          placeholder="••••••••"
          type="password"
          [value]="loginPassword"
          (valueChange)="loginPassword = $event"
          [errorMessage]="passwordError"
        ></app-text-input>

       <app-button type="submit" variant="primary" [fullWidth]="true" [disabled]="isLoading()">
  {{ isLoading() ? 'Logging in...' : 'Log In' }}
</app-button>
      </form>
    </div>
  </div>
</div>